/* PRODIG 自動目次: 記事本文の h2/h3 を走査して目次を自動生成・自動挿入。記事側の作業ゼロ。 */
(function () {
  function init() {
    // 記事ページ以外では何もしない（テーマ全体に貼っても勝手に記事だけで動く）
    var isArticle =
      /template-article/.test(document.body.className) ||
      /\/blogs\//.test(location.pathname) ||
      !!document.querySelector('.article-guide, .article-template, [itemprop="articleBody"]');
    if (!isArticle) return;
    var root =
      document.querySelector('.article-guide') ||
      document.querySelector('[itemprop="articleBody"]') ||
      document.querySelector('.article-template__content .rte') ||
      document.querySelector('.article-template .rte') ||
      document.querySelector('.article__body') ||
      document.querySelector('article .rte') ||
      document.querySelector('.rte');
    if (!root) return;
    if (root.querySelector('.pd-toc')) return; // 二重生成防止
    var heads = root.querySelectorAll('h2, h3');
    if (heads.length < 3) return; // 見出しが少ない記事は目次を出さない

    var nav = document.createElement('nav');
    nav.className = 'pd-toc';
    nav.setAttribute('aria-label', '目次');
    var title = document.createElement('div');
    title.className = 'pd-toc__title';
    title.innerHTML =
      '<span class="pd-toc__title-label">目次</span>' +
      '<button type="button" class="pd-toc__toggle" aria-expanded="true">閉じる</button>';
    var list = document.createElement('ol');
    list.className = 'pd-toc__list';

    var curH2 = null, curSub = null, i = 0;
    Array.prototype.forEach.call(heads, function (h) {
      var txt = (h.textContent || '').trim();
      if (!txt) return;
      if (!h.id) h.id = 'sec-' + (++i);
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = txt;
      li.appendChild(a);
      if (h.tagName === 'H2') {
        li.className = 'pd-toc__h2';
        list.appendChild(li);
        curH2 = li; curSub = null;
      } else {
        li.className = 'pd-toc__h3';
        if (curH2) {
          if (!curSub) {
            curSub = document.createElement('ol');
            curSub.className = 'pd-toc__sub';
            curH2.appendChild(curSub);
          }
          curSub.appendChild(li);
        } else {
          list.appendChild(li);
        }
      }
    });

    nav.appendChild(title);
    nav.appendChild(list);

    var firstH2 = root.querySelector('h2');
    if (firstH2 && firstH2.parentNode) firstH2.parentNode.insertBefore(nav, firstH2);
    else root.insertBefore(nav, root.firstChild);

    // 開閉
    title.querySelector('.pd-toc__toggle').addEventListener('click', function () {
      var collapsed = nav.classList.toggle('is-collapsed');
      this.setAttribute('aria-expanded', String(!collapsed));
      this.textContent = collapsed ? '開く' : '閉じる';
    });

    // スムーズスクロール（固定ヘッダー分オフセット）
    var links = [].slice.call(nav.querySelectorAll('a'));
    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        var t = document.getElementById(id);
        if (!t) return;
        e.preventDefault();
        var y = t.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top: y, behavior: 'smooth' });
        history.replaceState(null, '', '#' + id);
      });
    });

    // スクロールスパイ（現在地ハイライト）
    if ('IntersectionObserver' in window) {
      var map = {};
      links.forEach(function (a) { map[a.getAttribute('href').slice(1)] = a; });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            links.forEach(function (x) { x.classList.remove('is-active'); });
            var a = map[en.target.id];
            if (a) a.classList.add('is-active');
          }
        });
      }, { rootMargin: '-70px 0px -70% 0px' });
      Array.prototype.forEach.call(heads, function (h) { io.observe(h); });
    }
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
